export default {
  main: {
    textAlign: 'right',
  },
  bold: {
    fontWeight: 'bold',
  },
}
